export enum BranchCardAnalyticsEnum {
  CLICK_SCHEDULE_BRANCH = '[PAC WEB] Card Unidade - Clicou em "Quero agendar"',
  CLICK_VIEW_BRANCH = '[PAC WEB] Card Unidade - Clicou em "Ver unidade"',
  CLICK_OPEN_MAP_BRANCH_CARD = '[PAC WEB] Card Unidade - Clicou em "Abrir no mapa"',

  CLICK_BRANCH_AVATAR = '[PAC WEB] Card Unidade - Clicou no avatar da unidade',
  CLICK_BRANCH_NAME = '[PAC WEB] Card Unidade - Clicou no nome da unidade',

  CLICK_SHOW_MORE_BRANCHES = '[PAC WEB] Card Unidade - Clicou em "Mostrar mais unidades"',
  CLICK_EXPAND_BRANCH_ADDRESS_CITY_PAGE = '[PAC WEB] Home - Card Unidade - Lista de Unidades - Clicou em expandir endereço',
}
